var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(321 1888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10350",
    "data-name": "Group 10350",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_data",
    "data-name": "vuesax/outline/data",
    transform: "translate(-290.53 1708.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data",
    transform: "translate(620 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.736,9.473A4.736,4.736,0,1,1,9.473,4.736,4.734,4.734,0,0,1,4.736,9.473Zm0-6.889A2.153,2.153,0,1,0,6.889,4.736,2.154,2.154,0,0,0,4.736,2.583Z",
    transform: "translate(22.396 12.274)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.736,9.473A4.736,4.736,0,1,1,9.473,4.736,4.734,4.734,0,0,1,4.736,9.473Zm0-6.889A2.153,2.153,0,1,0,6.889,4.736,2.154,2.154,0,0,0,4.736,2.583Z",
    transform: "translate(22.396 2.153)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M4.736,9.473A4.736,4.736,0,1,1,9.473,4.736,4.734,4.734,0,0,1,4.736,9.473Zm0-6.889A2.153,2.153,0,1,0,6.889,4.736,2.154,2.154,0,0,0,4.736,2.583Z",
    transform: "translate(22.396 22.396)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.736,9.473A4.736,4.736,0,1,1,9.473,4.736,4.734,4.734,0,0,1,4.736,9.473Zm0-6.889A2.153,2.153,0,1,0,6.889,4.736,2.154,2.154,0,0,0,4.736,2.583Z",
    transform: "translate(2.153 12.274)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M15.052,2.583H.885C.4,2.583,0,2,0,1.292S.4,0,.885,0H15.052c.484,0,.885.586.885,1.292S15.536,2.583,15.052,2.583Z",
    transform: "translate(9.042 15.719)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M13.348,22.826H6.459C2.291,22.826,0,21.092,0,17.935V4.891C0,1.735,2.291,0,6.459,0h6.889c.706,0,1.292.443,1.292.978s-.586.978-1.292.978H6.459c-2.721,0-3.875.874-3.875,2.935V17.935c0,2.061,1.154,2.935,3.875,2.935h6.889c.706,0,1.292.443,1.292.978S14.054,22.826,13.348,22.826Z",
    transform: "translate(12.817 5.597)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H34.021V34.021H0Z",
    fill: "none",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_key",
    "data-name": "vuesax/outline/key",
    transform: "translate(-332 1727.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key",
    transform: "translate(681 187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15226",
    "data-name": "Path 15226",
    d: "M701.75,193.862l.759,3.611-1.174,2.049-2.611,2.337-3.041.637-1.522-.259-4.113,4.316-3.669-.7-.475-3.617,4.144-4.12v-3.1l1.038-2.483L693.4,190.5l3.456-.742,2.362,1,2.114,1.776Z",
    transform: "translate(-684.336 -188.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M4.059,17.692a2.332,2.332,0,0,1-.247-.016l-1.787-.247A2.162,2.162,0,0,1,.263,15.675l-.247-1.8a2.271,2.271,0,0,1,.576-1.746L4.207,8.511a6.863,6.863,0,1,1,4.982,4.965L5.566,17.091A2.217,2.217,0,0,1,4.059,17.692Zm6.793-16.46A5.617,5.617,0,0,0,5.483,8.511a.614.614,0,0,1-.156.618L1.457,13a1.063,1.063,0,0,0-.231.692l.247,1.8a.944.944,0,0,0,.7.708l1.8.247a1.021,1.021,0,0,0,.7-.222l3.887-3.878a.615.615,0,0,1,.618-.148A5.615,5.615,0,0,0,14.8,2.871,5.539,5.539,0,0,0,10.852,1.232Z",
    transform: "translate(1.03 1.041)",
    fill: "#c32bd6",
    stroke: "#c32bd6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M2.509,3.127a.611.611,0,0,1-.436-.181L.179,1.052A.617.617,0,0,1,1.052.179L2.946,2.073a.621.621,0,0,1,0,.873A.611.611,0,0,1,2.509,3.127Z",
    transform: "translate(5.058 13.786)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-10",
    "data-name": "Vector",
    d: "M1.853,3.705A1.853,1.853,0,1,1,3.705,1.853,1.855,1.855,0,0,1,1.853,3.705Zm0-2.47a.618.618,0,1,0,.618.618A.622.622,0,0,0,1.853,1.235Z",
    transform: "translate(10.087 5.97)",
    fill: "#c32bd6",
    stroke: "#c32bd6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-11",
    "data-name": "Vector",
    d: "M0,0H19.762V19.762H0Z",
    fill: "none",
    opacity: 0
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.5ce773cb2c5a64756c838ab97092b932.svg";
export { ForwardRef as ReactComponent };